import { GameTypes } from "kadow-jetpack-model";
import { tt } from "../i18n/i18n";

export function getDisplayNameForGameType(gameType: string) {
  switch (gameType as GameTypes) {
    case GameTypes.SlotMachine:
      return tt("game_type_slot_machine");
    case GameTypes.FortuneWheel:
      return tt("game_type_wheel_of_fortune");
    case GameTypes.Dice:
      return tt("game_type_3d_dice");
    case GameTypes.ScratchCard:
      return tt("game_type_scratch_card");
    case GameTypes.FlipCards:
      return tt("game_type_flip_cards");
    case GameTypes.Fakir:
      return tt("game_type_fakir_game");
    case GameTypes.MysteryBoxes:
      return tt("game_type_mystery_boxes");
    case GameTypes.MonthlyLottery:
      return tt("game_type_monthly_lottery");
    case GameTypes.Quiz:
      return tt("game_type_quiz");
    case GameTypes.Wordle:
      return tt("game_type_wordle");
    case GameTypes.Prognosis:
      return tt("game_type_prognosis");
    case GameTypes.Jumper:
      return tt("game_type_jumper");
    case GameTypes.Catcher:
      return tt("game_type_catcher");
    case GameTypes.Puzzle:
      return tt("game_type_puzzle");
    case GameTypes.BalloonBlast:
      return tt("game_type_balloon_blast");
    case GameTypes.KadowCrush:
      return tt("game_type_kadow_crush");
    case GameTypes.SpaceInvaders:
      return tt("game_type_space_invaders");
    case GameTypes.Breakout:
      return tt("game_type_breakout");
    case GameTypes.PenaltyKick:
      return tt("game_type_penalty_kick");
  }
}
